/**
 * /dashboard/accounting/sales/invoices/new — Create invoice (G_ACC5).
 *
 * Save Draft (POST /invoices) or Save & Send (POST /invoices then
 * /invoices/{id}/send). Both routes are accounting-admin role-gated.
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/sales/invoices/new/page.tsx
 * with PageHeader hoisted into AccountingModuleShell.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { InvoiceForm } from "@/components/accounting/invoice-form";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/sales/invoices/new",
)({
  component: NewInvoiceRoute,
});

function NewInvoiceRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <AccountingModuleShell
      title="New Invoice"
      description="Create a draft, or save and send to post to the journal."
    >
      <InvoiceForm />
    </AccountingModuleShell>
  );
}
